angular.module("app").directive("shapeColorTherapyChart", () => {
  let link = (scope) => {
    scope.dotsPerLine = [1, 2, 3, 4, 5];

    scope.getDotLines = percentage => {
      const dotLines = [];
      const rowCnt = Math.ceil(percentage / 100 * 25);
      for (let i = 0; i < rowCnt; i++) {
        dotLines.push(i);
      }

      return dotLines;
    };
  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbShapeColorTherapyChart/dbShapeColorTherapyChartView.html",
    link: link,
    scope: {
      colorData: "="
    }
  };
});
